import React, { Component } from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { extractFromUrl } from '../../actions'
import { isIOs, isMobile } from '../../misc/selectors'
import { processUploadedFiles } from '../../misc/utilities'

const mapStateToProps = (state, ownProps) => {
  const { videos, me } = state

  return {
    isIOs: isIOs(state),
    me,
    isMobile: isMobile(state),
  }
}

class StartCard extends Component {
  render() {
    return (
      <div className="start-pane">
        <h1>
          Let's get <b>started.</b>
        </h1>
        <form style={{ display: 'none' }}>
          <input
            id="upload-input"
            multiple={!this.props.isIOs}
            type="file"
            ref="fileInput"
            accept={this.props.isMobile ? "video/*" : null}
            onChange={() => {
              const files = this.refs.fileInput.files
              processUploadedFiles(this.props.dispatch, files, null, this.props.me.plan_max_length)
            }}
          />
        </form>
        <form
          className="form start-form"
          ref="form"
          onSubmit={(e) => {
            e.preventDefault()
            this.props.dispatch(extractFromUrl(this.refs.urlInput.value))
            browserHistory.push('/clipper')
          }}
        >
          <div className="upload start-form-pane">
            <input type="submit" style={{ visibility: 'hidden', position: 'absolute' }} />
            <button
              className="btn blue-button upload-button"
              onClick={(e) => {
                e.preventDefault()
                this.refs.fileInput.click()
              }}
            >Upload a video file</button>
          </div>
          <div className="clip start-form-pane">
            <div className="url-picker">
              <input
                className="form-control"
                id="primary-url-input"
                type="text"
                placeholder="       Paste a video URL"
                ref="urlInput"
                onPaste={(e) => {
                  let targetInput = e.target
                  setTimeout(() => {
                    this.props.dispatch(extractFromUrl(targetInput.value, this.props.groupId))
                    browserHistory.push('/clipper')
                  }, 0)
                }}
              />
            </div>
          </div>
        </form>
      </div>
    )
  }
}

export default connect(mapStateToProps)(StartCard)
